import React, { Component } from 'react'
import "./createstudy.css"
import {
  Container,
  Form,
  Button,
  NavLink,
  Spinner
} from 'reactstrap';
import Game from "../../../src/components/Picture/Factory438316_454596305_fullsize.jpg";
import Lightbox from "react-image-lightbox";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDice,
  faGamepad,
  faCloud,
  faLeaf,
  faShippingFast,
  faCheckSquare,
  faUsers,
  faUserTie,
  faCrown,
} from "@fortawesome/free-solid-svg-icons";
library.add(
  faDice,
  faGamepad,
  faCloud,
  faLeaf,
  faShippingFast,
  faCheckSquare,
  faUsers,
  faUserTie,
  faCrown
);

class CreateStudy6 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false
    };
  }
  render() {
    const { isOpen } = this.state;
    return (
      
      <div>
        <Container className="comming">
        <Form className="boxstudy6">
        <h5 className="textstudy">เรื่องพัฒนาการและภูมิปัญญาไทยทางด้านเศรษฐกิจในสมัยกรุงสุโขทัย</h5><br></br>

        <Form className="b1"><h5 className="textS">พัฒนาการด้านเศรษฐกิจในสมัยสุโขทัย</h5>
        <h5 className="dd"><Spinner type="grow" color="info" />ปัจจัยสำคัญที่ช่วยส่งเสริมให้สุโขทัยสามารถพัฒนาเศรษฐกิจให้เจริญก้าวหน้า มีหลายประการ ดังนี้</h5>
        <h5 className="dd">๑. ภูมิประเทศ สุโขทัยตั้งอยู่ในบริเวณที่ราบลุ่มแม่น้ำ ที่ราบเชิงเขาซึ่งเป็นแหล่งเพาะปลูก เลี้ยงสัตว์ และจับสัตว์น้ำ</h5>
        <h5 className="dd">๒. ทรัพยากรธรรมชาติ สุโขทัยมีพืชพรรณ และทรัพยากรธรรมชาติต่างๆ อย่างอุดมสมบูรณ์ เช่น ป่าไม้ สัตว์ป่า และแร่ธาตุต่างๆ</h5>
        <h5 className="dd">๓. ความสามรถของผู้นำ กษัตริย์ซึ่งเป็นผู้ปกครองกรุงสุโขทัย ทรงมีพระปรีชาสามารถในการคิดริเริ่มและดัดแปลงสิ่งแวดล้อมที่เอื้ออำนวยต่อการดำรงชีวิตของราษฎร เช่น สร้างทำนบกั้นน้ำไว้เพื่อเก็บกักน้ำ เรียกว่า ทำนบพระร่วง ส่งน้ำไปตามคูคลองสู่คูเมือง เพื่อระบายน้ำสู่พื้นที่เกษตรกรรม จึงทำให้ประชาชนมีน้ำใช้สอยอย่างเพียงพอ</h5>
       <br></br>
        <h5 className="dd"><Spinner type="grow" color="info" />พื้นที่ด้านเศรษฐกิจของสุโขทัยขึ้นอยู่กับอาชีพหลักของประชาชน 3 อาชีพ ได้แก่</h5>
        <h5 className="dd">๑.เกษตรกรรม สังคมสุโขทัยเป็นสังคมเกษตรกรรม อาชีพหลัก คือ การเพาะปลูก และเลี้ยงสัตว์ การเพาะปลูกจะมีทั้งการทำนา ทำไร่และทำสวน พืชที่ปลูกกันมาก เช่น ข้าว มะม่วง มะขาม หมาก พลู เป็นต้น บริเวณที่ใช้เป็นพื้นที่เพาะปลูก ได้แก่ ที่ราบลุ่มแม่น้ำปิง แม่น้ำยม และแม่น้ำน่าน</h5>
        <h5 className="dd"> ๒.หัตถกรรม หัตถกรรมที่สำคัญของสุโขทัย ส่วนใหญ่เป็นการผลิตเครื่องสังคโลก หรือเครื่องปั้นดินเผา เครื่องสังคโลกของสุโขทัยที่ผลิตได้ คือ จาน ชาม และถ้วยต่างๆ นอกจากนั้นยังนิยมผลิตเครื่องสังคโลกในรูปแบบต่างๆ ตามความต้องการของผู้ซื้อ เช่น แจกัน เหยือก โถน้ำ โอ่ง ไห เป็นตัน</h5>
        <h5 className="dd">๓.การค้าขาย การค้าขายในสมัยสุโขทัยเป็นการค้าขายแบบเสรี ทุกคนมีอิสระในการค้าขาย รัฐไม่จำกัดชนิดสินค้าและไม่เก็บเกี่ยวภาษีผ่านด่านที่เรียกว่า จังกอบ ผู้ใดอยากค้าขายอะไรก็ไม่มีการห้าม มีการค้าสัตว์ชนิดต่างๆ เช่น ช้าง ม้า วัว ควาย เป็นต้น ตลอดจนการค้าแร่เงินและแร่ทอง นอกจากจะมีสินค้าขายภายในราชอาณาจักรแล้ว ยังมีการขายและแลกเปลี่ยนสินค้ากับอาณาจักรต่างๆ ที่อยู่ภายนอกอาณาจักรสุโขทัยอีกด้วย</h5>
        
            <img className="photo4"
              width="700"
              height="700"
          onClick={() => this.setState({ isOpen: true })}
          src={Game}
          alt="QRcode"
          
        ></img>
        {isOpen && (
          <Lightbox
            mainSrc={Game}
            onCloseRequest={() => this.setState({ isOpen: false })}
          />
        )}
        <h5 className="dd" align='center'>กลุ่มเรือจำลอง(เรือฉลอมชายฝั่ง)</h5>
        </Form>

        <p h5 align='center'><Button href='/study' outline color="warning" >ย้อนกลับ</Button>{' '}</p>
          <p h5 align='center'><Button href='/createStudy7' outline color="primary" >บทถัดไป</Button>{' '}</p>
        
        </Form>
        </Container>

        <div className="footer text-footer">
          <p>Surasak   Noorurk</p>
          <p> Project 5935512072 Computer Engineering</p>           
          <NavLink href="https://surasak783023869.wordpress.com/">ช่องทางการติดต่อ</NavLink>
        </div>

      </div>
    )
  }
}

export default CreateStudy6